import {
  DOC_FILE_TYPES,
  EXCEL_FILE_TYPES,
  IMAGE_FILE_TYPES,
  VIDEO_FILE_TYPES,
} from 'constant/file';

export const checkIsPdf = (mime_type: string | undefined) =>
  mime_type?.toLowerCase() === 'pdf';

export const checkIsExcel = (mimeType?: string): boolean => {
  if (!mimeType) return false;
  const extension = mimeType.toLowerCase().startsWith('.')
    ? mimeType.toLowerCase()
    : `.${mimeType.toLowerCase()}`;
  return EXCEL_FILE_TYPES.includes(extension);
};

export const checkIsImage = (mimeType?: string): boolean => {
  if (!mimeType) return false;
  const extension = mimeType.toLowerCase().startsWith('.')
    ? mimeType.toLowerCase()
    : `.${mimeType.toLowerCase()}`;
  return IMAGE_FILE_TYPES.includes(extension);
};

export const checkIsImageByMimeType = (mimeType?: string): boolean => {
  if (!mimeType) return false;
  return mimeType.startsWith('image/');
};

export const checkIsDoc = (mimeType?: string): boolean => {
  if (!mimeType) return false;
  const extension = mimeType.toLowerCase().startsWith('.')
    ? mimeType.toLowerCase()
    : `.${mimeType.toLowerCase()}`;
  return DOC_FILE_TYPES.includes(extension);
};

export const checkIsHeic = (file: File) =>
  file.name.toLowerCase().endsWith('.heic') ||
  file.name.toLowerCase().endsWith('.heif') ||
  file.type === 'image/heic' ||
  file.type === 'image/heif';

export const convertMbToBytes = (mb: number) => mb * 1024 * 1024;

/**
 * Formats bytes into human-readable file size
 * @param bytes - Size in bytes (can be string or number)
 * @param decimals - Number of decimal places (default: 2)
 * @returns Formatted string like "1.5 MB" or "-" if invalid
 */
export const formatFileSize = (
  bytes: string | number | undefined | null,
  decimals = 2,
): string => {
  if (bytes === undefined || bytes === null || bytes === '') return '-';

  const numBytes = typeof bytes === 'string' ? Number.parseFloat(bytes) : bytes;

  if (Number.isNaN(numBytes) || numBytes < 0) return '-';
  if (numBytes === 0) return '0 Bytes';

  const bytesPerUnit = 1024;
  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const unitIndex = Math.floor(Math.log(numBytes) / Math.log(bytesPerUnit));
  const convertedSize = numBytes / Math.pow(bytesPerUnit, unitIndex);

  return `${Number.parseFloat(convertedSize.toFixed(decimals))}${units[unitIndex]}`;
};

export const checkIsVideo = (mimeType?: string): boolean => {
  if (!mimeType) return false;
  const extension = mimeType.toLowerCase().startsWith('.')
    ? mimeType.toLowerCase()
    : `.${mimeType.toLowerCase()}`;
  return VIDEO_FILE_TYPES.includes(extension);
};

export const checkIsVideoByMimeType = (mimeType?: string): boolean => {
  if (!mimeType) return false;
  return mimeType.startsWith('video/');
};

// Helper function to check if the media is a video
export const isVideoFile = (mimeType?: string) =>
  checkIsVideo(mimeType) || checkIsVideoByMimeType(mimeType);
